import { createSelector } from 'reselect';

export const getByCode = ({ labelSymbolCorrectiveAction }) => labelSymbolCorrectiveAction.byCode;
export const getCodes = ({ labelSymbolCorrectiveAction }) => labelSymbolCorrectiveAction.list.allCodes;
export const getLabelSymbolCorrectiveAction = (state, code) => getByCode(state)[code];
export const getLabelSymbolCorrectiveActionList = createSelector([getCodes, getByCode], (allCodes, byCode) =>
  allCodes.map(code => byCode[code]),
);
